<app-skuba-login-form (submitted)="onSubmit($event)" [pending]="isLoginPending" [errorMessage]="error$ | async" [infoMessage]="infoMessage">

</app-skuba-login-form>
